import {LobbyImage, SharedStrings} from '@colonist/types'
import {UIImagePathController} from '../UIEnums.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'

export const ACTIVE_OPACITY = 1
export const INACTIVE_OPACITY = 0.4

export function isCloseTo(value1: number, value2: number, margin: number): boolean {
    if(value1 + margin > value2 &&
        value1 - margin < value2) {
        return true
    }
    return false
}

export function isElement(o: any) {
    return (
        typeof HTMLElement === 'object' ? o instanceof HTMLElement : // DOM2
            o != undefined && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
    )
}

export function logError(functionName: string, logs: any[]) {
    const text = 'Something went wrong, please contact admins at ' + SharedStrings.SUPPORT_EMAIL + '  with copying this log' +
        ' and explaining what actions you took right before this error.'
    /* eslint-disable no-console */
    console.log(text)
    /* eslint-enable no-console */
    logDebugInfo(functionName, logs)
}

export function logDebugInfo(functionName: string, logs: any[]) {
    /* eslint-disable no-console */
    console.info(functionName)
    for(const log of logs) {
        console.info(log)
    }
    /* eslint-enable no-console */
}

export function removeURLParams() {
    window.history.replaceState(null, '', window.location.pathname + window.location.hash)
}

// https://stackoverflow.com/a/5298684
export function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search)
}

export function getImagePath(file: string): string {
    return UIImagePathController.getImagePath(file, UIUtilsEjsVariables.isUserOnDiscord)
}

export function getLobbyImagePath(img: LobbyImage): string {
    return UIImagePathController.getImgPath(img)
}
